/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from "react";
import { Tooltip } from "react-tippy";
import t from "../../Common/utils/translation/translator";

const getUtilizationPercentage = (col, output, filters, unit, minimal = false) => {
  //console.log("getUtilizationPercentage filters", filters);
  const input = filters?.applicationDataFilter?.[col];
  // utilization percentage is ( input / output ) * 100 rounded to 2 decimals if needed
  const utilization = Math.round((input / output) * 100 * 10) / 10;
  /*
    - if utilization is below 90% : green
    - if utilization is > 90% : yellow
    */
  const utilizationColorHexa = utilization < 90 ? "#008a16" : "#E47F00";
  const utilizationColor = utilization < 90 ? "text-thresholdsGreen" : "warningOrange";

  const formatColName = (colName) => colName.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

  const formattedColName = formatColName(col);

  return !minimal ? (
    <Tooltip
      html={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <span>{`${utilization}% ${t(`msizer.ui.${formattedColName}_utilization_percentage`)} (${input} ${unit})`}</span>
      }
      position="bottom"
      trigger="mouseenter"
      duration={200}
      arrow
      size="small"
      theme="light"
    >
      <div className="flex flex-col space-y-1 md:space-y-0 md:flex-row space-x-1 items-center">
        <div className="flex-1">{`${output} ${unit}`}</div>
        <div className="flex-1 flex flex-col space-y-1 w-full">
          <span className={`${utilizationColor} font-semibold`}>{utilization}%</span>
          <div
            className="h-2 w-full rounded-full"
            style={{
              background: `linear-gradient(90deg, ${utilizationColorHexa} ${utilization}%, #E5E7EB ${utilization}%)`
            }}
          />
        </div>
      </div>
    </Tooltip>
  ) : (
    <div>{`${output} ${unit}`}</div>
  );
};

export default getUtilizationPercentage;
